export default "/cheongwadae.glb";